import { ApolloError } from "@apollo/client";
import { AddToast } from "react-toast-notifications";

export const handleApolloError = (error: ApolloError, addToast: AddToast) => {
  return error.graphQLErrors.forEach(error => addToast(error.message, { appearance: "error" }));
};
